var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMail = function SvgMail(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M16.735 8.302c-.612.453-1.422 1.031-4.211 2.961A5 5 0 0 1 10 12.503a5 5 0 0 1-2.521-1.24c-2.789-1.93-3.6-2.505-4.214-2.958A.164.164 0 0 0 3 8.427v5.323A1.283 1.283 0 0 0 4.313 15h11.375A1.283 1.283 0 0 0 17 13.75V8.425a.165.165 0 0 0-.265-.123M10 11.667c.634.01 1.548-.76 2.007-1.078 3.628-2.508 3.9-2.727 4.741-3.352A.61.61 0 0 0 17 6.745V6.25A1.283 1.283 0 0 0 15.688 5H4.313A1.283 1.283 0 0 0 3 6.25v.495a.62.62 0 0 0 .252.492c.837.622 1.113.844 4.741 3.352.459.317 1.373 1.088 2.007 1.078"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMail);
export default ForwardRef;